// @vendors
const trim = require('lodash/string/trim');
const { get } = require('lodash');

// @constants
const {
    EURO_TEXT,
    ACCOUNT_INTERVENTION_OWNER,
    BROKER_TRANSFER_FUNDS_ALL,
} = require('constants/index');
const {
    VALID_ACCOUNT_SUBTYPES,
    VALID_ACCOUNT_TYPE,
} = require('../raConstants/index');

// @utilities
const { formatText } = require('core/i18n').i18n;

const sortImmtByKey = (object, key) => {
    return object.sort(function(a, b) {
        if (a.get(key) > b.get(key)) {
            return 1;
        }
        if (a.get(key) < b.get(key)) {
            return -1;
        }
        return 0;
    });
};

const buildAccountsDropdownOptions = (
    immAccounts,
    needFilterId = false,
    selectedIds = [],
) => {
    const filteredAccounts = immAccounts
        .get('byId')
        .filter(
            account =>
                account.get('interventionType') ===
                    ACCOUNT_INTERVENTION_OWNER &&
                account.get('newProduct') === VALID_ACCOUNT_TYPE &&
                VALID_ACCOUNT_SUBTYPES.includes(account.get('accountType')) &&
                account.getIn(['balances', 'availableBalance', 'currency']) ===
                    EURO_TEXT &&
                !account.getIn(['filters', 'block']) &&
                (!needFilterId ||
                    selectedIds.indexOf(account.get('accountId')) !== -1),
        );

    const processedStocksContract = sortImmtByKey(
        filteredAccounts,
        'newProduct',
    ).map(account => ({
        value: account.get('accountId'),
        associatedAccount: account.getIn(['ibanComplex', 'codbban']),
        walletBalance: account.getIn(['balances', 'availableBalance']),
        walletNumber: account.get('contractNumber'),
        walletAccountType: account.get('description'),
        newWalletNumber: account.get('newContractNumber'),
    }));

    return processedStocksContract;
};

const validTypesAccounts = (
    immAccounts,
    validTypes = [],
    validSubtypes = [],
) => {
    const filteredAccounts = immAccounts
        .get('byId')
        .filter(
            account =>
                account.get('interventionType') ===
                    ACCOUNT_INTERVENTION_OWNER &&
                validTypes.includes(account.get('newProduct')) &&
                validSubtypes.includes(account.get('accountType')) &&
                account.getIn(['balances', 'availableBalance', 'currency']) ===
                    EURO_TEXT &&
                !account.getIn(['filters', 'block']),
        );

    const processedStocksContract = sortImmtByKey(
        filteredAccounts,
        'newProduct',
    ).map(account => ({
        value: account.get('accountId'),
        walletBalance: account.getIn(['balances', 'availableBalance']),
        walletNumber: account.get('contractNumber'),
        walletAccountType: account.get('description'),
        newWalletNumber: account.get('newContractNumber'),
    }));

    return processedStocksContract;
};

// This function is temporally active until we get the real data from API svc
const buildFundsDropdownOptions = (immAccounts, accountIds) => {
    const allOptionLabel = formatText(
        'raHireManagementPlanStep1-raHireManagementPlanStep1_allOptionLabel',
    );
    const filteredAccounts = accountIds.map(accountId =>
        immAccounts.getIn(['byId', accountId]),
    );

    const processedStocksContract = filteredAccounts.map(account => ({
        value: account.get('accountId'),
        name: account.get('alias'),
        newContractNumber: account.getIn(['ibanComplex', 'codbban']),
        interventionType: account.get('interventionType'),
        accountHolder: account.get('accountHolder'),
        balance: account.get('balance'),
    }));

    const ALLKey = 111111;
    const ALLObj = {
        value: BROKER_TRANSFER_FUNDS_ALL,
        name: allOptionLabel,
        newContractNumber: 0,
        interventionType: '',
        accountHolder: '',
        balance: 0,
    };

    const processedStocksContractWithAll = processedStocksContract.set(
        ALLKey,
        ALLObj,
    );

    return processedStocksContractWithAll;
};

const getOldIbanContract = (ibanData, oldProductContract) => {
    const foundContract = ibanData.find(data => {
        return get(data, 'codIban.codbban').match(oldProductContract);
    });

    let ibanContract;
    if (!!foundContract) {
        ibanContract = trim(
            get(foundContract, 'codIban.pais', '') +
                get(foundContract, 'codIban.digitodecontrol', '') +
                get(foundContract, 'codIban.codbban', ''),
        );
    } else {
        ibanContract = '';
    }

    return ibanContract;
};

module.exports = {
    buildAccountsDropdownOptions,
    buildFundsDropdownOptions,
    validTypesAccounts,
    getOldIbanContract,
};
